import { useState } from "react";
import { addInputsForm } from "../../lib/actions";
import DropDown from "../../components/GDropDownList/DropDown";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function AddInputsUi({typeOfInputs}) {

    const nav = useNavigate();
    const [typeId, setTypeId] = useState(null)
    const [check, setCheck] = useState(true);
    const [loading, setLoading] = useState(false);
    const { i18n } = useTranslation();
    const t = i18n.t.bind(i18n); 
    const currentLang = i18n.language;

    const handleChangeCheck = () => {
        setCheck(!check);
    };

    const onchange = (e) => {
        setTypeId(e);
    };

    const handleSubmit = async (e) => {
        setLoading(true);
        e.preventDefault();
        const formData = new FormData(e.target);
            formData.set("required", check === true ? 1 : 0);
        const result = await addInputsForm(formData, navigate);
        setLoading(false);
    };

    const navigate = (route) => {
        nav(route);
    };

    return (
        <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-1  md:grid-cols-2 sm:grid-cols-1 gap-3">
                <div className="mb-4">
                    <label className="block text-white mb-2"> {currentLang === "en" ? "name in arabic" : "الاسم باللغة العربية "} </label>
                    <input
                        type="text"
                        name="name_ar"
                        className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 rounded-lg text-white"
                        required
                        placeholder={currentLang === "en" ? "enter name in arabic" : "أدخل الاسم باللغة العربية "}
                    />
                </div>
                <div className="mb-4">
                    <label className="block text-white mb-2">{currentLang === "en" ? "name in english" : "الاسم باللغة الانجيليزية "}</label>
                    <input
                        type="text"
                        name="name_en"
                        className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg"
                        required
                        placeholder={currentLang === "en" ? "enter name in english" : " أدخل الاسم باللغة الانجليزية "}
                    />
                </div>
                <div className="mb-4">
                    <label className="block text-white mb-2">{currentLang === "en" ? "input type" : "نوع الحقل"}</label>
                    <DropDown defaultText={currentLang === "en" ? "choose input type" : "اختر نوع الحقل"} value={typeId} options={typeOfInputs} paramkey={"type"} onchange={onchange} />
                </div>
                <div className="mb-4">
                    <label className="block text-white mb-2">{currentLang === "en" ? "entry terms" : "شروط الادخال "} </label>
                    <input
                        type="text"
                        name="regex"
                        className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg"
                        
                        placeholder={currentLang === "en" ? "enter entry terms" : "أدخل شروط الادخال"}
                    />
                </div>
                <div className="flex gap-4 sm:flex-row flex-col sm:justify-between items-start">
                    <div className="flex flex-row justify-center items-center gap-6">
                    <div className="flex items-center gap-3">
                        <div
                            onClick={handleChangeCheck}
                            className={`relative w-14 h-6 rounded-full cursor-pointer transition
                            ${check ? (currentLang === 'ar' ? 'bg-secondary' : 'bg-secondary') : (currentLang === 'ar' ? 'bg-gray-400' : 'bg-gray-400')}`}
                        >
                            <span
                            className={`w-5 h-4 mt-1 bg-white rounded-full shadow-md block
                                transform transition
                                ${check ? (currentLang === 'ar' ? '-translate-x-1' : 'translate-x-7') : (currentLang === 'ar' ? '-translate-x-7' : 'translate-x-1')}`}
                            />
                        </div>
                        <label className="text-white">
                        {check
                            ? currentLang === "en"
                            ? "require"
                            : "حقل اجباري"
                            : currentLang === "en"
                            ? "optional"
                            : "حقل اختياري"
                        }
                        </label>
                    </div>
                    </div>
                </div>
            </div>
            <div className="flex justify-center w-full mt-5">
                <button
                    type="submit"
                    disabled={loading}
                    className={`w-full sm:w-2/5 md:w-[14%] bg-secondary text-white py-2 rounded-lg transition flex items-center justify-center ${loading ? "cursor-not-allowed" : "hover:bg-primary"
                        }`}
                >
                    {loading ? (
                        <>
                            <svg
                                className="animate-spin h-5 w-5 " xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" ></circle>
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
                            </svg>
                        </>
                    ) : (
                        t("button.save")
                    )}
                </button>
            </div>
        </form>
    );
};